import BrowserService from '@/services/browserService'

export default (user, userId, product, params) => {
  const payload = ({
    event: 'remove_from_cart',
    platform: BrowserService.platform(),
    sessionId: BrowserService.sessionId(),
    ecommerce: {
      currency: product.currencyCode,
      products: [
        {
          id: product.id,
          name: product.name,
          favorite: params.isFavorite,
          categories: product.categories.map((c) => {
            return c.title
          }),
          labels: product.properties.map((p) => {
            return p.name
          }),
          availability: 'stock',
          price: product.price,
          currency: product.currencyCode,
          discount: 0,
          quantity: params.quantity,
        },
      ],
      user: user,
    },
    _clear: true,
  })
  if (userId) payload.user_id = userId
  if (params.source) payload.source = params.source
  window.dataLayer?.push(payload)
}
